// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3q7y2","footer":"styles_footer__YJsFw"};